<template>
  <div>
    <v-layout class="ma-4">
      {{ $t('document.download.message') }}
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    documentID: {
      type: String,
      required: true
    }
  },
  mounted () {
    let url = this.$cove.getAPI({
      name: 'api.publicAccessDocuments.download',
      params: { documentID: this.documentID }
    });

    window.location.replace(url);
  }
};
</script>
